module.exports = __webpack_public_path__ + "img/beer-mug-empty.ceec0e47.svg";